import { getUIState } from "../../../../../utils/selectors";

export const getGraphicsData = (state) => getUIState(state).graphicsData
export const getECMode = (state) => getUIState(state).ecMode
export const getActiveTab = (state) => getUIState(state).activeTab
